export default "__VITE_ASSET__DaQfgzhf__"